<template>
    <v-dialog
        v-model="$store.state.privateStations.addStation"
        max-width="500px"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text"
                    >Add Stations</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.privateStations.addStation = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid v-if="spinner">
                
                <v-row style="margin-top: 0px;padding-bottom: 0px;">
                    <v-col style="margin-top: 0px;padding-bottom: 0px;">
                        <v-combobox
                            v-model="station"
                            :items="stations"
                            dense
                            label="Station"
                            required
                            :rules="[v => !!v || 'Required']"
                            :item-text="'Name'"
                            :item-value="'id'"
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-combobox
                            v-model="product"
                            :items="all"
                            dense
                            label="Products"
                            required
                            :rules="[v => !!v || 'Required']"
                            :item-text="'Product'"
                            :item-value="'ProductID'"
                        >
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-container grid-list-xs>
                    
                <v-row justify="end">
                    <v-btn color="success" @click="add()">Save</v-btn>
                </v-row>
                </v-container>
            </v-container>
            <v-container grid-list-xs v-else>
                <v-row justify="center" class="mt-3 mb-3">
                    <v-col cols="1">
                        <div class="sk-chase">
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                            <div class="sk-chase-dot"></div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            all: null,
            stations: [],
            station:[],
            product:[],
            stationsProd:[],
            spinner: false
        };
    },
    mounted() {
        this.loadPrivateStations();
    },
    methods: {
        loadPrivateStations: function(){
            var str = this.$store;
            axios
                .get('product-station-priv/distinct', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.stationsProd = response.data;
                    console.log(this.stationsProd);
                    this.loadStations();
                    this.loadAllProducts();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        loadAllProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.all = response.data.data;
                        this.spinner = true;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadStations: function() {
            var str = this.$store;
            axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data.data.length);
                    this.stations = response.data.data;
                    console.log()
                    await  this.stationsProd.forEach(prd => {
                        this.stations.forEach((stt,idx) => {
                            if(prd.Station == stt.id){
                                this.stations.splice(idx, 1);
                            }
                        });
                    });
                    console.log(this.stations.length);
                    this.spinner=true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        add: function() {
            var str = this.$store;
            if (this.product.ProductID == undefined || this.station.id == undefined) {
                str.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'It is necessary to complete the form!!'
                });
            } else {
                var parms = {
                    Station: this.station.id,
                    Product: this.product.ProductID
                };

                this.spinner = false;
                axios
                    .post('product-station-priv', parms, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.$store.state.privateStations.watch = true;
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Station Save'
                        });
                        this.$store.state.privateStations.addStation = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        },
        
    }
};
</script>
